var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup69(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 44,
    viewBox: "0 0 150 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.g{fill:#fff;font-family:Roboto-Regular, Roboto;}.b{font-size:10px;}.c{fill:#00d8fe;}.d{fill:#00ef75;}.e{fill:#fec900;}.f{fill:#ee2f4b;}.g{font-size:18px;}.h,.i{stroke:none;}.i{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-216 -655)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(216 655)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4,0H146a4,4,0,0,1,4,4V40a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M 4 0.5 C 2.070098876953125 0.5 0.5 2.070098876953125 0.5 4 L 0.5 40 C 0.5 41.92990112304688 2.070098876953125 43.5 4 43.5 L 146 43.5 C 147.9299011230469 43.5 149.5 41.92990112304688 149.5 40 L 149.5 4 C 149.5 2.070098876953125 147.9299011230469 0.5 146 0.5 L 4 0.5 M 4 0 L 146 0 C 148.2091369628906 0 150 1.790859222412109 150 4 L 150 40 C 150 42.20914077758789 148.2091369628906 44 146 44 L 4 44 C 1.790863037109375 44 0 42.20914077758789 0 40 L 0 4 C 0 1.790859222412109 1.790863037109375 0 4 0 Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(262 669)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Get on ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 1.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.387,13.689a3.181,3.181,0,0,0-.128.886V41.711a3.227,3.227,0,0,0,.125.875l15.23-14.429Z",
    transform: "translate(220.735 647.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M45.838,10.345,28.056.454a2.6,2.6,0,0,0-2-.39L41.354,14.6Z",
    transform: "translate(206.916 661.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M186.647,105.46l-4.312-2.4-4.417,4.183,4.5,4.276,4.2-2.3C188.661,108.05,187.914,106.171,186.647,105.46Z",
    transform: "translate(70.246 568.782)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M25.65,171.773a2.557,2.557,0,0,0,2.022-.372l17.673-9.7-4.524-4.3Z",
    transform: "translate(207.508 518.511)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(262 688)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google Play")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup69);
export default __webpack_public_path__ + "static/media/Group 69.78d0c39874f8d331b3c8323e733547a0.svg";
export { ForwardRef as ReactComponent };